Px.Editor.CalendarElement = class CalendarElement extends Px.Editor.GroupElement {};
